import forgotPasswordComponentTemplate from "./forgotPasswordComponentTemplate.js";
import { userIcon, eyeIcon, eyeSlashIcon, buildCircle } from "../LoginComponent/LoginComponentIcons.js";
import forgotPasswordMessages from "../../constants/forgotPasswordMessages.js";
const sendCode = `configuration/user/password/send-reset-code`;
const sendResendCode = `configuration/user/password/submit-reset-code`;
import { environment } from '../../environments/environment';
const api = `${environment.api}`;

export default class CEGuidelineCognitoForgotPassword extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });
    const template = document.createElement("template");
    template.innerHTML = forgotPasswordComponentTemplate;
    shadow.appendChild(template.content.cloneNode(true));
    this.shadowRoot.querySelector("#submit-verfication-code").innerText = forgotPasswordMessages.VERIFICATION_CODE_BUTTON_TEXT;
    this.shadowRoot.querySelector("#submit-verfication-code").addEventListener("click", this.onVerificationCodeSent.bind(this));
    this.shadowRoot.querySelector("#forgotpassowrd-form-submit").addEventListener("click", this.onResetPasswordSent.bind(this));
    this.shadowRoot.querySelector("#forgot-password-eye-icon-button").addEventListener("click", this.showHidePassword.bind(this));
    this.shadowRoot.querySelector("#forgotpasswordemail").addEventListener("change", this.onEmailChange.bind(this));
    this.shadowRoot.querySelector("#verification-code").placeholder = forgotPasswordMessages.VERIFICATION_CODE_PLACEHOLDER;
    this.shadowRoot.querySelector("#new-password").placeholder = forgotPasswordMessages.PASSWORD_PLACEHOLDER;
    // this.shadowRoot.querySelector("#new-password").addEventListener("change", this.validatePassword.bind(this));
    this.shadowRoot.querySelector("#forgot-password-username").placeholder = forgotPasswordMessages.EMAIL_PLACEHOLDER;
    this.shadowRoot.querySelector("#backtologin").innerText = forgotPasswordMessages.BACK_TO_SIGN_IN_TEXT;
    this.shadowRoot.querySelector("#backtologin").addEventListener("click", this.onBackToSignIn.bind(this));
    this.shadowRoot.querySelector("#resend-code-button").addEventListener("click", this.onResendCode.bind(this));
    this.shadowRoot.querySelector("#resend-code-button").innerText = forgotPasswordMessages.RESEND_CODE_BUTTON_TEXT;
    this.resendCountdownInterval = null;
    this.resendCountdownSeconds = 0;
    this.addIcons();
  }

  disconnectedCallback() {
    if (this.resendCountdownInterval) {
      clearInterval(this.resendCountdownInterval);
      this.resendCountdownInterval = null;
    }
  }

  addIcons() {
    const userImages = this.shadowRoot.querySelectorAll(".user-icon3");
    const eyeImages = this.shadowRoot.querySelectorAll(".eye-icon");
    const buildImages = this.shadowRoot.querySelectorAll(".buildIcon");

    userImages.forEach((image) => {
      image.setAttribute("src", userIcon);
    });

    eyeImages.forEach((image) => {
      image.setAttribute("src", eyeIcon);
    });

    buildImages.forEach((image) => {
      image.setAttribute("src", buildCircle);
    });
  }

  showCodeSentErrorMessage(customMessage = null) {
    const errorMessage = this.shadowRoot.querySelector(
      "#forgot-password-code-error-message"
    );
    errorMessage.style.display = "block";
    const message = customMessage || forgotPasswordMessages.CODE_SENT_ERROR_MESSAGE;
    errorMessage.innerText = message;
  }

  showPasswordResetErrorMessage(customMessage = null) {
    const errorMessage = this.shadowRoot.querySelector(
      "#forgot-password-error-message"
    );
    errorMessage.style.display = "block";
    const message = customMessage || forgotPasswordMessages.PASSWORD_RESET_ERROR_MESSAGE;
    errorMessage.innerText = message;
  }

  extractErrorMessage(errorResponse) {
    try {
      const payload = errorResponse?.Payload || errorResponse?.payload;
      if (payload && typeof payload === 'object') {
        const values = Object.values(payload);
        const flattened = values.flatMap((v) => Array.isArray(v) ? v : [v]);
        const messages = flattened
          .map((v) => typeof v === 'string' ? v : (v?.message || JSON.stringify(v)))
          .filter(Boolean);
        if (messages.length) {
          return String(messages[0]);
        }
      }
      return errorResponse?.Detail || errorResponse?.detail || errorResponse?.title || errorResponse?.message || null;
    } catch (e) {
      return null;
    }
  }

  showResetPassword() {
    const email = (this.shadowRoot.querySelector("#forgotpasswordemail").value || '').toLowerCase().trim();
    this.shadowRoot.querySelector("#reset-password-form").style.display = "block";
    this.shadowRoot.querySelector("#verfication-code-form").style.display = "none";
    if (email) {
      this.shadowRoot.querySelector("#forgot-password-username").value = email;
    }
    this.startResendCountdown();
    const submitButton = this.shadowRoot.querySelector("#forgotpassowrd-form-submit");
    submitButton.disabled = true;
    this.shadowRoot.querySelector("#forgot-password-username").addEventListener("input", this.updateSubmitButtonState.bind(this));
    this.shadowRoot.querySelector("#verification-code").addEventListener("input", this.updateSubmitButtonState.bind(this));
    this.shadowRoot.querySelector("#new-password").addEventListener("input", this.updateSubmitButtonState.bind(this));
    this.updateSubmitButtonState();
  }

  onBackToSignIn() {   
    setTimeout(function(){
      window.location.reload();
    });
  }

  async onVerificationCodeSent(e) {
      e.preventDefault();
      const email = (this.shadowRoot.querySelector("#forgotpasswordemail").value || '').toLowerCase().trim();

      if (!email || !this.validateEmail(email)) {
          return;
      }
      const submitButton = this.shadowRoot.querySelector("#submit-verfication-code");
      submitButton.disabled = true;
      try {
          const response = await fetch(`${api}/${sendCode}`, {
              method: 'POST',
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  UserEmail: email
              })
          });
          if (!response || response.status !== 200) {
            let errorMessage = null;
            try {
              const errorData = await response.json();
              errorMessage = this.extractErrorMessage(errorData);
            } catch (parseError) {
            }
            this.showCodeSentErrorMessage(errorMessage);
            return;
          }
          this.showResetPassword();

      } catch (e) {
          this.showCodeSentErrorMessage();
      } finally {
          submitButton.disabled = false;
      }
  }

  validatePassword(event) {
    const value = event.target.value;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.[\]{}()?""!@#%&/\\,><':;|_~`=+-])[A-Za-z\d\^$*.[\]{}()?""!@#%&/\\,><':;|_~`=+-]{8,}$/;
    
    if (!passwordRegex.test(value)) {
      const errorMessage = this.shadowRoot.querySelector("#forgot-password-error-message");
      errorMessage.style.display = "block";
      const message = forgotPasswordMessages.PASSWORD_VALIDATION_ERROR_MESSAGE;
      errorMessage.innerText = message;
    } else {
      const errorMessage = this.shadowRoot.querySelector("#forgot-password-error-message");
      errorMessage.style.display = "none";
    }
  }

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      const errorMessage = this.shadowRoot.querySelector("#forgot-password-code-error-message");
      errorMessage.style.display = "block";
      const message = forgotPasswordMessages.EMAIL_VALIDATION_ERROR_MESSAGE;
      errorMessage.innerText = message;
      return false
    } else {
      const errorMessage = this.shadowRoot.querySelector("#forgot-password-code-error-message");
      errorMessage.style.display = "none";
      return true;
    }    
  }

  onEmailChange(event) {
    const value = event.target.value;
    this.validateEmail(value);
  }

  updateSubmitButtonState() {
    const { email, verificationCode, newPassword } = this.getFormValues();
    const submitButton = this.shadowRoot.querySelector("#forgotpassowrd-form-submit");
    if (submitButton) {
      submitButton.disabled = !(email && verificationCode && newPassword);
    }
  }

  getFormValues() {
    const email = (this.shadowRoot.querySelector("#forgot-password-username").value || '').toLowerCase().trim();
    const verificationCode = this.shadowRoot.querySelector("#verification-code").value;
    const newPassword = this.shadowRoot.querySelector("#new-password").value;

    return {
        email,
        verificationCode,
        newPassword
    };
  }

  validateForm() {
      const { email, verificationCode, newPassword } = this.getFormValues();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.[\]{}()?""!@#%&/\\,><':;|_~`=+-])[A-Za-z\d\^$*.[\]{}()?""!@#%&/\\,><':;|_~`=+-]{8,}$/;
      const newLine = "<br>";
      const displayBlock = "block";
      const displayNone = "none";
      const bullet = "&#8226; ";
      let valid = true;

      const errorMessage = this.shadowRoot.querySelector("#forgot-password-error-message");
      errorMessage.innerHTML = "";
      errorMessage.style.display = displayNone;

      if (!email || !verificationCode || !newPassword) {
          errorMessage.style.display = displayBlock;
          errorMessage.innerHTML += bullet + forgotPasswordMessages.ALL_FIELDS_REQUIRED_ERROR_MESSAGE + newLine;         
          valid = false;         
      }

      if (!emailRegex.test(email)) {
          errorMessage.style.display = displayBlock;
          errorMessage.innerHTML += bullet + forgotPasswordMessages.EMAIL_VALIDATION_ERROR_MESSAGE + newLine;
          valid = false;
      }

      if (!passwordRegex.test(newPassword)) {
          errorMessage.style.display = displayBlock;
          errorMessage.innerHTML += bullet + forgotPasswordMessages.PASSWORD_VALIDATION_ERROR_MESSAGE;
          valid = false;
      }

      return valid;
  }

  async onResetPasswordSent(e) {
      e.preventDefault();

      if (!this.validateForm()) {
          return;
      }

      const { email, verificationCode, newPassword } = this.getFormValues();
      const displayBlock = "block";

      try {
        const response = await fetch(`${api}/${sendResendCode}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            UserEmail: email,
            NewPassword: newPassword,
            ConfirmationCode: verificationCode,
          }),
        });

        if (response.status !== 200) {
          let errorMessage = null;
          try {
            const errorData = await response.json();
            errorMessage = this.extractErrorMessage(errorData);
          } catch (parseError) {
          }
          this.showPasswordResetErrorMessage(errorMessage);
          return;
        }

        const data = await response.json();

        this.shadowRoot.querySelector("#forgot-password-sucess-message").style.display = displayBlock;
        this.shadowRoot.querySelector("#forgot-password-sucess-message").innerText = forgotPasswordMessages.PASSWORD_RESET_SUCCESS_MESSAGE;
        setTimeout(() => {
          location.reload(true);
        }, 5000);
      } catch (e) {
          this.showPasswordResetErrorMessage();
      }

    /*  this._cognito.completePasswordReset(email, verificationCode, newPassword).then((data) => {
              this.shadowRoot.querySelector("#forgot-password-sucess-message").style.display = displayBlock;
              this.shadowRoot.querySelector("#forgot-password-sucess-message").innerText = forgotPasswordMessages.PASSWORD_RESET_SUCCESS_MESSAGE;
              setTimeout(() => {
                location.reload(true);
              }, 5000);
          }).catch((err) => {
              console.log(err);
              this.showPasswordResetErrorMessage();
          }); */
  }

  showHidePassword() {
    const passwordInput = this.shadowRoot.querySelector("#new-password");
    const eyeIconElement = this.shadowRoot.querySelector("#forgot-password-eye-icon");
    passwordInput.type = passwordInput.type === "password" ? "text" : "password";
    eyeIconElement.setAttribute('src', passwordInput.type === "password" ? eyeIcon : eyeSlashIcon);
  }

  startResendCountdown() {
    if (this.resendCountdownInterval) {
      clearInterval(this.resendCountdownInterval);
    }
    this.resendCountdownSeconds = 120;
    const resendButton = this.shadowRoot.querySelector("#resend-code-button");
    resendButton.disabled = true;
    this.updateResendButtonText();
    this.resendCountdownInterval = setInterval(() => {
      this.resendCountdownSeconds--;
      this.updateResendButtonText();
      if (this.resendCountdownSeconds <= 0) {
        clearInterval(this.resendCountdownInterval);
        this.resendCountdownInterval = null;
        resendButton.disabled = false;
        resendButton.innerText = forgotPasswordMessages.RESEND_CODE_BUTTON_TEXT;
      }
    }, 1000);
  }

  updateResendButtonText() {
    const resendButton = this.shadowRoot.querySelector("#resend-code-button");
    const minutes = Math.floor(this.resendCountdownSeconds / 60);
    const seconds = this.resendCountdownSeconds % 60;
    const minutesPlural = minutes !== 1 ? "s" : "";
    const secondsPlural = seconds !== 1 ? "s" : "";
    const text = forgotPasswordMessages.RESEND_CODE_COUNTDOWN_TEXT
      .replace("{minutes}", minutes)
      .replace("{minutesPlural}", minutesPlural)
      .replace("{seconds}", seconds)
      .replace("{secondsPlural}", secondsPlural);
    resendButton.innerText = text;
  }

  async onResendCode(e) {
    e.preventDefault();
    const email = (this.shadowRoot.querySelector("#forgot-password-username").value || '').toLowerCase().trim();
    if (!email || !this.validateEmail(email)) {
      return;
    }
    const resendButton = this.shadowRoot.querySelector("#resend-code-button");
    resendButton.disabled = true;
    try {
      const response = await fetch(`${api}/${sendCode}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          UserEmail: email
        })
      });
      if (!response || response.status !== 200) {
        let errorMessage = null;
        try {
          const errorData = await response.json();
          errorMessage = this.extractErrorMessage(errorData);
        } catch (parseError) {
        }
        this.showCodeSentErrorMessage(errorMessage);
        resendButton.disabled = false;
        return;
      }
      this.startResendCountdown();
    } catch (e) {
      this.showCodeSentErrorMessage();
      resendButton.disabled = false;
    }
  }

  get cognito() {
    return this._cognito;
  }

  set cognito(value) {
    this._cognito = value;
  }
}
